// src/context/site/kbFailureCopy.js — why the last Knowledge Base job failed, from `kb-status.failure_code`
// (a CLOSED list, BE 5cd9175). `null` (a job that failed before the field existed) or a code we do not know
// falls back to the generic sentence. Every remedy names «Rileggi tutto il Sito», the one base-view button: the
// contract's [Reindex] remedy for an unfinished job is covered by it (v201 decision — reload is the superset).
const FAILURE_KEYS = {
  DISCOVERY_FOUND_NOTHING: 'site.failure.foundNothing',
  SITE_APEX_CONFLICT: 'site.failure.siteChanged',
  DISCOVERY_REFUSED: 'site.failure.unreadable',
  CREDITS_UNAVAILABLE: 'site.failure.credits',
  INDEX_REFUSED: 'site.failure.unfinished',
  INTERRUPTED: 'site.failure.unfinished',
  INTERNAL_ERROR: 'site.failure.unfinished',
  STALE: 'site.failure.unfinished',
};

// The failures that are about the SITE ADDRESS. After the address has been saved again (and until the next job),
// telling the user to check it would contradict what they just did — the card and «Gestisci» hide these two.
const ADDRESS_FAILURES = new Set(['DISCOVERY_FOUND_NOTHING', 'DISCOVERY_REFUSED']);

/** Whether a Failed job's sentence is shown: an address failure is hidden once the address was saved again. */
export function showKbFailure(code, addressFixed) {
  return !(addressFixed && ADDRESS_FAILURES.has(code));
}

export function kbFailureHint(t, code) {
  return t(FAILURE_KEYS[code] || 'site.failedHint');
}
